// Integration licenses
export const LICENSE_HID_MOBILE_ACCESS = "37";
export const LICENSE_STID_MOBILE = "46";
export const LICENSE_VINGCARD = "64";
export const LICENSE_SSO_ENTRA = "72";

// Mobile reader licenses
export const LICENSE_MDRSE_STID = "48";
export const LICENSE_MDRSE_HID = "49";
export const LICENSE_MDRSE_STID_HID = "50";

// License status
export const LICENSE_STATUS = {
    OK: 1,
    EXPIRED: 2,
    EXPIRING_SOON: 3,
    INCOMPATIBLE_VERSION: 4
}

// System usage as defined in the license file
export const USAGE = {
    ON_PREM: 2,
    CLOUD_CI: 3, // Impro-hosted cloud
    CLOUD_CS: 4 // Self-hosted cloud
}

export const isCloud = (usage) => {
    return (usage === USAGE.CLOUD_CI || usage === USAGE.CLOUD_CS);
}

export const isImproHostedCloud = (usage) => {
    return (usage === USAGE.CLOUD_CI);
}

export const isLicWarningRequired = (status) => {
    if (typeof status === 'undefined') return false;
    return status !== LICENSE_STATUS.OK;
}

/**
 * The license will no longer function, e.g., expired or incompatible version.
 * We need to show a stronger warning to the user.
 * @param status 
 */
export const isLicInvalid = (status) => {
    if (typeof status === 'undefined') return false;
    return status === LICENSE_STATUS.EXPIRED || status === LICENSE_STATUS.INCOMPATIBLE_VERSION;
}

/**
 * The license has already expired and the system has been reverted to Demo mode.
 * @param status 
 */
export const isLicExpired = (status) => {
    if (typeof status === 'undefined') return false;
    return status === LICENSE_STATUS.EXPIRED;
}

/**
 * The license will soon expire and the system will then revert to Demo Mode.
 * @param status 
 */
export const isLicExpiringSoon = (status) => {
    if (typeof status === 'undefined') return false;
    return status === LICENSE_STATUS.EXPIRING_SOON;
}

/**
 * The license is not compatible with this software release.
 * The license needs to be of a specific version. E.g., Primo v2026.X needs a license versioned for 2026.X.
 * @param status 
 */
export const isLicIncompatibleVersion = (status) => {
    if (typeof status === 'undefined') return false;
    return (status === LICENSE_STATUS.INCOMPATIBLE_VERSION)
}